/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Person_Company_Identifier_ConflictInputs */

const en_case_validation_person_company_identifier_conflict = /** @type {(inputs: Case_Validation_Person_Company_Identifier_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An individual debtor cannot have a CNPJ.`)
};

const pt_br2_case_validation_person_company_identifier_conflict = /** @type {(inputs: Case_Validation_Person_Company_Identifier_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um devedor pessoa física não pode ter CNPJ.`)
};

/**
* | output |
* | --- |
* | "An individual debtor cannot have a CNPJ." |
*
* @param {Case_Validation_Person_Company_Identifier_ConflictInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_person_company_identifier_conflict = /** @type {((inputs?: Case_Validation_Person_Company_Identifier_ConflictInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Person_Company_Identifier_ConflictInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_person_company_identifier_conflict(inputs)
	return pt_br2_case_validation_person_company_identifier_conflict(inputs)
});